import type { RaceFormat, SportType, UserRace } from "../types/iosModels";

export const parsePlateNumber = (value: unknown): number | null =>
  typeof value === "number" && Number.isSafeInteger(value) && value > 0 ? value : null;

export const getRacePlateShape = (
  sport: SportType,
  format?: RaceFormat
): "bib" | "compact" | "handlebar" => {
  if (sport === "Run" || sport === "Trail Run") return "bib";
  if (format?.kind === "downhill" || format?.kind === "enduro") return "handlebar";
  if (sport === "Mountain Bike" || sport === "E-Mountain Bike") return "handlebar";
  return "compact";
};

export const selectRaceParticipation = (races: UserRace[], raceId: string, testResetGeneration = 0): UserRace | null =>
  races.filter(race => race.raceId === raceId && (race.testResetGeneration ?? 0) === testResetGeneration).sort((a, b) =>
    Number(a.status === "Cancelled") - Number(b.status === "Cancelled") ||
    (b.attemptNumber ?? 0) - (a.attemptNumber ?? 0) ||
    (b.startDate?.getTime() ?? 0) - (a.startDate?.getTime() ?? 0)
  )[0] ?? null;
